import React from "react";
import { createRoot } from "react-dom/client";
import "core-js/es";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import App from "./App";

import "./main.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const root = createRoot(document.querySelector("#root"));
root.render(<App />);